import { create } from 'zustand';

interface ClubManagementTourState {
  pending: boolean;
  requestTour: () => void;
  clearPending: () => void;
}

export const useClubManagementTourStore = create<ClubManagementTourState>((set) => ({
  pending: false,
  requestTour: () => set({ pending: true }),
  clearPending: () => set({ pending: false }),
}));
